'use client';
import React, { useState } from 'react';
import PhoneLoginForm from './PhoneLoginForm';
import OTPVerifyForm from './OTPVerifyForm';
import RegisterForm from './RegisterForm';
import AuthBrandPanel from './AuthBrandPanel';
import AppLogo from '@/components/ui/AppLogo';

export type AuthView = 'login' | 'otp' | 'register';
export type UserRole = 'customer' | 'staff';

export interface AuthState {
  phone: string;
  role: UserRole;
  view: AuthView;
}

export default function AuthPage() {
  const [authState, setAuthState] = useState<AuthState>({
    phone: '',
    role: 'customer',
    view: 'login',
  });

  return (
    <div className="min-h-screen flex bg-background">
      {/* Brand panel — hidden on mobile */}
      <div className="hidden lg:flex lg:w-[52%] xl:w-[55%]">
        <AuthBrandPanel />
      </div>

      {/* Form panel */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 min-h-screen">
        <div className="w-full max-w-md">
          {/* Mobile logo */}
          <div className="flex items-center gap-2.5 mb-10 lg:hidden">
            <AppLogo src="/assets/sifibank-logo.svg" size={36} />
          </div>

          {authState.view === 'login' && (
            <PhoneLoginForm authState={authState} setAuthState={setAuthState} />
          )}
          {authState.view === 'otp' && (
            <OTPVerifyForm authState={authState} setAuthState={setAuthState} />
          )}
          {authState.view === 'register' && (
            <RegisterForm authState={authState} setAuthState={setAuthState} />
          )}
        </div>
      </div>
    </div>
  );
}